// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'right',
    //suggestionWidth: 'auto'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {};
  SearchInput.prototype._onClickSearchBox = function(event) {
    // Close more
    if (Utils.isMobile()) $( "body .js-search-draw .js-close-mfp").trigger("click");
  };
  // jQ('.js-search-trigger').on('click', function() {
  // 	jQ('body').addClass('boost-pfs-custom-open-search-mobile');
  // });
})();